import React from "react";
import ReactGA from "react-ga";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import { ConnectedRouter } from "connected-react-router";
import AuthProvider from "./auth";
import ModalProvider from "./modules/modalProvider";
import { IStore } from "./resources/types";
import config from "./config";
import configureStore from "./resources/store";
import Layout from "./pages/layout";

ReactGA.initialize(config.gaTrackingId);

const history = createBrowserHistory();

interface IProps {
  children: React.ReactChild | React.ReactChild[];
}

const initialState: IStore = {};
const store = configureStore(initialState, history);

function ReduxProviderWrap({ children }: IProps) {
  return <Provider store={store}>{children}</Provider>;
}

export default function App() {
  return (
    <React.StrictMode>
      <ReduxProviderWrap>
        <ConnectedRouter history={history}>
          <AuthProvider>
            <Layout />
            <ModalProvider />
          </AuthProvider>
        </ConnectedRouter>
      </ReduxProviderWrap>
    </React.StrictMode>
  );
}
